import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VForm,{ref:"form",attrs:{"autocomplete":"new-password","lazy-validation":_vm.lazy},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c(VTextField,{attrs:{"label":"Email","name":"login","prepend-icon":"mdi-account","type":"text","rules":_vm.emailRules,"color":"secondary"},model:{value:(_vm.formData.email),callback:function ($$v) {_vm.$set(_vm.formData, "email", $$v)},expression:"formData.email"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }